import React from 'react'
import { Grid } from '@mui/material'
import { useSelector } from 'react-redux'
import AssesmentArea from './AssesmentArea'
import { setChildrenData } from '../../utils'

const FormCurriculumElements = ({ onChangeAlert }) => {
  const formData = useSelector((state) => state?.lc?.form?.curriculumElements || {})
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {})
  const [form, setInputForm] = React.useState(formData)
  const [errors, setInputErrors] = React.useState({})

  if (!currentCurriculum || !currentCurriculum?.elements || !currentCurriculum.elementsStructure) return <></>
  const onChange = (name, value) => {
    const formData = setChildrenData(form, name, value)
    setInputForm(formData)
    setInputErrors({ ...errors, [name]: null })
    onChangeAlert('curriculumElements', formData)
  }

  return (
    <Grid container spacing={2}>
      <AssesmentArea
        element={currentCurriculum?.elements}
        elementData={currentCurriculum?.elementsStructure}
        childrenElements={currentCurriculum?.elements?.children}
        form={form}
        errors={{}}
        onChange={onChange}
      />
    </Grid>
  )
}

export default FormCurriculumElements